import { useEffect, useState } from "react";
import { Wrench } from "lucide-react";
import {
  fetchMaintenanceStatus,
  getMaintenanceState,
  subscribeMaintenance,
} from "../utils/maintenanceAxios";

const LOGO_URL = "/images/logo-full.png";
const POLL_MS = 30_000;

function formatEstimatedEnd(value) {
  if (!value) return null;
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return String(value);
    return d.toLocaleString("it-IT", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return String(value);
  }
}

export default function MaintenancePage() {
  const [info, setInfo] = useState(getMaintenanceState());

  useEffect(() => subscribeMaintenance(setInfo), []);

  useEffect(() => {
    let cancelled = false;

    const poll = async () => {
      const data = await fetchMaintenanceStatus();
      if (cancelled) return;
      if (data && data.enabled === false) {
        window.location.replace("/");
      }
    };

    poll();
    const id = setInterval(poll, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  const estimated = formatEstimatedEnd(info.estimated_end);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-emerald-50 flex items-center justify-center p-6">
      <div className="w-full max-w-lg text-center">
        <img
          src={LOGO_URL}
          alt="Affidya"
          className="h-14 mx-auto mb-8 object-contain"
        />
        <div className="rounded-2xl border border-slate-200 bg-white/90 shadow-sm px-8 py-10">
          <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-amber-100">
            <Wrench className="h-7 w-7 text-amber-600" strokeWidth={2} aria-hidden />
          </div>
          <h1 className="text-2xl font-bold text-slate-900 mb-3">
            Manutenzione in corso
          </h1>
          <p className="text-slate-600 leading-relaxed">
            {info.message ||
              "Affidya è temporaneamente in manutenzione. Riprova tra poco."}
          </p>
          {estimated && (
            <p className="mt-4 text-sm text-slate-500">
              Ripresa stimata:{" "}
              <span className="font-medium text-slate-700">{estimated}</span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
